<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <h3 class="p-2">
        <small class="text-muted">User Profile</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label>First Name</label>
            <input type="text" class="form-control" v-model="mm.firstName" id="firstName" aria-describedby="action">
        </div>
        <div class="form-group col-3">
            <label>Last Name</label>
            <input type="text" class="form-control" v-model="mm.lastName" id="lastName" aria-describedby="action">
        </div>
        
    </div>
    <div class="row">
        <div class="form-group col-3">
            <label for="module">Email</label>
            <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module">
        </div>
        <div class="form-group col-3">
            <label for="module">Phone Number</label>
            <input type="text" class="form-control" v-model="mm.phoneNumber" id="phoneNumber" aria-describedby="module">
        </div>
        <div class="form-group col-3">
            <label>New Password</label>
            <input type="password" class="form-control" v-model="mm.password" id="newPassword" aria-describedby="password">
        </div>
    </div>

    <!-- <div class="row">
        <div class="form-group col-3">
            <label>New Password</label>
            <input type="password" class="form-control" v-model="mm.password" id="newPassword" aria-describedby="password">
        </div>
        <div class="form-group col-3">
            <label>Retype New Password</label>
            <input type="password" class="form-control" v-model="mm.passwordRetype" id="newpasswordRetype" aria-describedby="passwordretype">
        </div>
    </div> -->

    <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="mm.mailManagementDetail"></app-datatable> -->
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
    <br /><br />
</div>
</template>

<script>
import api from '../services/api'
import { memberManagement } from '../models/memberManagement'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatatable from '../components/AppDatatable.vue'
import AppDatePicker from '../components/AppDatePicker.vue'
import AppNavBar from '../components/AppNavbar.vue'
import { mapActions } from 'vuex'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppNavBar
    },
    data() {
        return {
            mm: {
                ...memberManagement
            }
        }
    },
    async created() {
        // if(this.$route.query.id !== undefined) {
        //     const mmApi = api('user-profile')
        //     this.mm = await mmApi.get()
        //     // this.mm = await mmApi.getWithParams(this.$route.query.id)
        // }
        const mmApi = api('user-profile')
        this.mm = await mmApi.get()
    },
    methods: {
        ...mapActions(['updateProfile']),
        async save() {
            const mmApi = api('user-profile')
            const profile = await mmApi.update(this.mm)
            this.updateProfile(profile)
            this.$router.go(-1)
            
            // if(this.$route.query.id !== undefined) {
            //     console.log('a')
            //     await mmApi.update(this.mm, this.$route.query.id)
            // } else {
            //     console.log('b')
            //     await mmApi.create(this.mm)
                
            // }
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentMM = this.mm
            this.mm = {
                ...currentMM,
                ...data
            }
        }
    }
}
</script>